import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addVerifyTagData: [],
};

export const AddVerifyTagDataSlice = createSlice({
  name: "addVerifyTagData",
  initialState,
  reducers: {
    getAddVerifyTagDataAction: (state, action) => {
      state.addVerifyTagData = action.payload;
    },
  },
});

export default AddVerifyTagDataSlice.reducer;

export const { getAddVerifyTagDataAction } = AddVerifyTagDataSlice.actions;
